import { useState } from "react";
import { Home, Sliders, Disc3, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "consultation",
    n: "01",
    title: "Home Recordings",
    icon: Home,
    blurb:
      "Learn how to record like a pro from your own space. 1-on-1 consultations covering room treatment, mic technique, signal flow, and capturing radio-ready takes - without booking studio time.",
  },
  {
    id: "mixing",
    n: "02",
    title: "Mixing",
    icon: Sliders,
    blurb:
      "Turn raw tracks into a polished, balanced mix. Meticulous attention to detail, creative direction, and reference-grade tools to bring your vision to life.",
  },
  {
    id: "mastering",
    n: "03",
    title: "Mastering",
    icon: Disc3,
    blurb:
      "Finish strong. Radio, streaming, vinyl - masters tuned to translate on any playback system while preserving the dynamics and character of your record.",
  },
];

export const Services = () => {
  const [hovered, setHovered] = useState(null);
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white border-t-2 border-black"
    >
      <div className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-black/60 mb-4">
              [ 002 / Capabilities ]
            </p>
            <h2 className="font-display uppercase leading-[0.85] tracking-tighter text-5xl sm:text-6xl md:text-7xl">
              Services
            </h2>
          </div>
          <p className="max-w-md text-black/70">
            End-to-end audio production, tailored to the project. Pick a chapter
            or book a discovery call.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-2 border-black">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const isActive = hovered === s.id;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                onMouseEnter={() => setHovered(s.id)}
                onMouseLeave={() => setHovered(null)}
                className={`group relative p-8 md:p-10 transition-colors duration-300 cursor-default ${
                  i > 0 ? "md:border-l-2 border-black" : ""
                } ${i > 0 ? "border-t-2 md:border-t-0" : ""} ${
                  isActive ? "bg-black text-white" : "bg-white text-black"
                }`}
              >
                <div className="flex items-start justify-between mb-12">
                  <span
                    className={`font-mono text-[11px] tracking-[0.25em] ${
                      isActive ? "text-white/60" : "text-black/50"
                    }`}
                  >
                    {s.n}
                  </span>
                  <Icon size={28} strokeWidth={1.5} />
                </div>

                <h3 className="font-display text-4xl md:text-5xl uppercase tracking-tighter leading-none mb-6">
                  {s.title}
                </h3>
                <p
                  className={`text-sm md:text-base leading-relaxed ${
                    isActive ? "text-white/80" : "text-black/70"
                  }`}
                >
                  {s.blurb}
                </p>

                <div
                  className={`mt-10 flex items-center gap-3 font-mono text-[11px] tracking-[0.25em] uppercase ${
                    isActive ? "text-white" : "text-black"
                  }`}
                >
                  Learn More
                  <ArrowUpRight
                    size={14}
                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
